import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerGeneralComponent } from './spinner-general.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [SpinnerGeneralComponent],
  imports: [
    CommonModule,
    MatProgressSpinnerModule
  ],
  exports: [SpinnerGeneralComponent]
})
export class SpinnerGeneralModule { }
